module.exports = __webpack_public_path__ + "static/media/market-research-validation-second.17b68e90.jpg";